import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import CruzIcon from "_+_Portal/assets/images/generico/CruzIcon";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";
import { useContext, useState } from "react";
import { ContainerNumeroAfiliado } from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import {
  setNumeroAfiliado,
  wsPutNroAfiliado,
} from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";

const NumeroAfiliado = ({ turnoActual, setLoading }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    pasoState,
    turnosSeleccionadosState,
    puntoControlDispatch,
    laboratorioDispatch,
    turnosSeleccionadosDispatch,
  } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);

  const [nroAfiliado, setNroAfiliado] = useState("");
  // -------------------------  context ----------------------------

  // -------------------------  constants ----------------------------
  const paciente = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
    : authState.auth.data.paciente;
  const cobertura = paciente.cobertura;
  const isParticular = cobertura?.idCobertura === "PART";
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;
  const turno = listTurnosSeleccionado && listTurnosSeleccionado[turnoActual];
  const nroAfiliadoExist =
    cobertura?.afiliado.length > 1 || turno?.nro_afiliado;
  // -------------------------  constants ----------------------------

  // -------------------------  funtion ----------------------------
  const success = () => {
    if (pasoState.circuito === "labo") {
      setPaso("ResumenLabo")(pasoDispatch);
    } else {
      if (turno) {
        setPaso("Resumen")(pasoDispatch);
      } else {
        setPaso("AgendasDisponibles")(pasoDispatch);
      }
    }
  };

  const fail = () => {
    // setTurnosSeleccionado(turno)(turnosSeleccionadosDispatch);
    const idTipoPuntoControl = 3;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const finalizar = (isCorrect, data) => {
    const nroAfiliado = data?.nro_afiliado;
    if (isCorrect) {
      setNumeroAfiliado(nroAfiliado)(laboratorioDispatch);
      if (pasoState.circuito === "labo") {
        setPaso("ResumenLabo")(pasoDispatch);
      } else {
        setPaso("Resumen")(pasoDispatch);
      }
    } else {
      fail();
    }
  };

  const ingresarAfiliado = () => {
    if (nroAfiliado.length > 1) {
      setLoading("Cargando...");
      setPaso("Loading")(pasoDispatch);
      wsPutNroAfiliado(nroAfiliado)(finalizar);
    }
  };

  const changeInput = (e) => {
    const value = e.target.value;
    setNroAfiliado(value);
  };

  // -------------------------  funtion ----------------------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin"}
      handleClick={() => {
        turno
          ? setPaso("TurnosDelDia")(pasoDispatch)
          : setPaso("Home")(pasoDispatch);
      }}
      type={"no-circle"}
      title={"VERIFICACIÓN DE DATOS"}
    >
      <ContainerNumeroAfiliado
        initial={{ opacity: 0, y: -90 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <div className="content">
          <span>
            Antes de iniciar el proceso de recepción le pedimos que{" "}
            <span className="bold">
              verifique la información sobre su cobertura médica
              {!nroAfiliadoExist ? "e ingrese el número de afiliado" : ""}
            </span>{" "}
            a continuación:
          </span>
          <span>
            Obra Social: <span className="bold">{cobertura?.cobertura}</span>
          </span>
          <span>
            Plan: <span className="bold">{cobertura?.plan}</span>
          </span>
          <span>
            {!isParticular && "Número de Afiliado:"}
            {!nroAfiliadoExist && !isParticular ? (
              <input
                onChange={changeInput}
                className="nroAfiliado-input"
                type="number"
                placeholder="Ej: 12321343"
              />
            ) : (
              <span className="bold">
                {" "}
                {cobertura?.afiliado ? cobertura.afiliado : turno?.nro_afiliado}
              </span>
            )}
          </span>
          <span>¿Son los datos correctos?</span>
          <div className="container-btn">
            {!nroAfiliadoExist && !isParticular ? (
              <button
                className="bgc-primary c-white"
                onClick={ingresarAfiliado}
              >
                Ingresar
              </button>
            ) : (
              <>
                <button className="bgc-danger c-white" onClick={fail}>
                  <CruzIcon
                    width={"15"}
                    height={"15"}
                    color={"var(--color-white)"}
                  />{" "}
                  No
                </button>
                <button className="bgc-broccoli c-white" onClick={success}>
                  <TildeOk
                    width={"15"}
                    height={"15"}
                    color={"var(--color-white)"}
                  />{" "}
                  Si
                </button>
              </>
            )}
          </div>
        </div>
      </ContainerNumeroAfiliado>
    </LayoutPasos>
  );
};
export default NumeroAfiliado;
